import { Text, Title } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'

import styles from './UnplannedCard.module.css'

export const UnplannedCard: FC = () => {
  const { t } = usePlanningFormTranslation()

  return (
    <div className={styles.BreakRow} id='planned-card'>
      <Title size={4} className={styles.UnplannedTitle}>
        {t('shiftRealHoursForm.plannedCard.title')}
      </Title>
      <div className={styles.BreakCol}>
        <Text size='m' className={styles.UnplannedText}>
          Non planifié
        </Text>
      </div>
    </div>
  )
}
